import { baseRTKApi } from 'shared/api/baseApi';

import { BFF_API_ROUTES } from '../../../../constants';
import type { ILoansData, ILoansDataParams } from '../types';

export const loansDataApi = baseRTKApi.injectEndpoints({
  endpoints: (builder) => ({
    getLoansData: builder.mutation<ILoansData[], ILoansDataParams>({
      query: ({ type, sum, term }) => ({
        url: `${BFF_API_ROUTES.getLoansData}`,
        params: { type, sum, term },
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetLoansDataMutation } = loansDataApi;
